/*
权限校验：
通过router路由前置钩子函数 beforeEach() ，
在跳转路由前进行拦截判断是否已经登录，
如果已登录，则进行路由跳转，如果没有则回到登录页
*/
import router from '@/router'
import {mockLogin} from '@api/mockapi'
/*
 前置路由钩子函数
 to ：即将要进入的目标路由对象
 from ：当前导航正要离开的路由对象
 next : 调用该方法，进入目标路由
*/

router.beforeEach((to, from, next) => {
  // 登录完成后需要同时保留两个信息 一个是token 一个是用户信息
  // 从本地缓存中获取 token



  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 判断路由是否需要进行权限判断 需要则执行 不需要则直接进行路由跳转
    const token =  localStorage.getItem('murToken')
    if (!token) {
      // 本地缓存中没有 token
      if (to.path !== '/login') {
        // 不允许访问其他路由, 回到登录页
        next({path: '/login'})
      } else {
        // 当前已经在登录页
        next()
      }
    } else {
      // 本地缓存中存在 token
      if (to.path === '/login') {
        // 当前为登录页 直接进入目标路由
        next()
      } else {
        // 有token, 看下是否有用户信息
        const userInfo =  localStorage.getItem('murUserInfo')
        if (userInfo) {
          // 本地缓存中存在用户信息, 进入目标路由
          next()
        } else {
          // 本地缓存中不存在用户信息 因此通过token发出请求获取用户信息
          mockLogin({keyword: token}).then((res) => {
            console.log(res.data)
            if(res.code === '0') {
              // 请求成功, 将数据保存到本地缓存中,再进行路由跳转
              localStorage.setItem('murUserInfo', JSON.stringify(res.data))
              next()
            }else {
              // 未获取到用户信息,可根据后台返回message,然后回到登录页
              next({path: '/login'})
            }
          })
        }
      }
    }
  } else {
    next()
  }
})
